import { ACCESS_COOKIE_NAME } from '@pequity/shared/types/constants';

const ACCESS_TOKEN_KEY = 'access_token';
const ACCESS_TOKEN_CHANGED_EVENT = 'pequity:access-token-changed';

const notifyAccessTokenChanged = (): void => {
  window.dispatchEvent(new Event(ACCESS_TOKEN_CHANGED_EVENT));
};

export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

export const setAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  document.cookie = `${ACCESS_COOKIE_NAME}=Bearer ${token}; path=/;`;
  notifyAccessTokenChanged();
};

export const removeAccessToken = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  notifyAccessTokenChanged();
};

export const onAccessTokenChanged = (callback: () => void): (() => void) => {
  const handleStorage = (event: StorageEvent) => {
    if (event.key === ACCESS_TOKEN_KEY) callback();
  };

  window.addEventListener(ACCESS_TOKEN_CHANGED_EVENT, callback);
  window.addEventListener('storage', handleStorage);

  return () => {
    window.removeEventListener(ACCESS_TOKEN_CHANGED_EVENT, callback);
    window.removeEventListener('storage', handleStorage);
  };
};

export const tokenExpired = (token: string): boolean => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiresAtMs = payload.exp * 1000 - 15000;
    return expiresAtMs < Date.now();
  } catch {
    return true;
  }
};

export const hasValidToken = (): boolean => {
  const token = getAccessToken();
  return !!token && !tokenExpired(token);
};
